import { PageComponent, PageState, PageSubset } from "barba"
import TinySlider from "utils/tiny-slider"

class GalleryClass {

    constructor({ node }) {
        this.node = node
        this.id = this.node.id
        this.slider = null
        this.items = this.node.querySelectorAll('.gallery__item')
        this.mediaViewerId = this.node.dataset.mediaViewerId

        this.clickHandler = this.click.bind(this)
        this.node.addEventListener("click", this.clickHandler)

        this.sliderOpts = () => ({
            container: this.node.querySelector('.gallery__tns'),
            prevButton: this.node.querySelector('.gallery__prev'),
            nextButton: this.node.querySelector('.gallery__next'),
            nav: false,
            autoWidth: true,
            gutter: this.gutter(),
            center: true,
            loop: true,
            speed: 500,
            startIndex: this.id && PageState.get(this.id) ? PageState.get(this.id) || 0 : 0,
            onInit: () => {
                this.node.classList.remove("opacity-0")
            }
        })

        if (this.items.length > 1) {
            this.slider = new TinySlider(this.sliderOpts)
            if (this.id) {
                this.slider.events.on('indexChanged', i => {
                    PageState.set(this.id, Math.max(0, i.displayIndex - 1))
                })
            }
        }
    }

    gutter() {
        if (window.matchMedia("(min-width: 1440px)").matches) {
            return 48
        }
        if (window.matchMedia("(min-width: 992px)").matches) {
            return 32
        }
        if (window.matchMedia("(min-width: 768px)").matches) {
            return 24
        }
        return 16
    }

    click(e) {
        const item = e.target.closest('.gallery__item')
        if (!item) return
        const index = item.dataset.slideIndex
        PageSubset.open(this.mediaViewerId, { 'startIndex': Math.max(0, index) })
    }

    destroy() {
        this.node.removeEventListener("click", this.clickHandler)

        if (this.slider && this.slider.destroy) {
            this.slider.destroy()
        }
        
        delete this.node
        delete this.id
        delete this.slider
        delete this.items
        delete this.mediaViewerId
        delete this.clickHandler
        delete this.sliderOpts
    }

}

new PageComponent(".gallery", GalleryClass)